import { title } from 'assets/jss/material-kit-react.js'

import imagesStyle from 'assets/jss/material-kit-react/imagesStyles.js'

const designStyle = {
  section: {
    padding: '10px 0',
    textAlign: 'center',
  },
  title: {
    ...title,
    marginBottom: '2rem',
    marginTop: '30px',
    minHeight: '32px',
    textDecoration: 'none',
  },
  titleIcon: {
    marginRight: '5px',
    fontSize: '2.25rem',
  },
  itemGrid: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  ...imagesStyle,
  imgMyStyle: {
    width: '100%',
  },
  imgBackground: {
    height: '180px',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    textAlign: 'center',
    '&:after': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: '""',
      backgroundColor: 'rgba(0, 0, 0, 0.56)',
      borderRadius: '6px',
    },
    '@media (max-width: 830px)': {
      marginTop: '10px',
      marginBottom: '10px',
    },
    '@media (max-width: 576px)': {
      marginTop: '10px',
      marginBottom: '10px',
    },
  },
  cardContent: {
    position: 'relative',
    zIndex: '2',
    minHeight: '280px',
    paddingTop: '60px',
    maxWidth: '440px',
    margin: '0 auto',
    color: 'white',
    fontWeight: '600',
  },
  cardHeader: {
    width: 'auto',
    textAlign: 'center',
    marginLeft: '20px',
    marginRight: '20px',
    marginTop: '-40px',
    padding: '20px 0',
    marginBottom: '15px',
  },
  cardFooter: {
    paddingTop: '0rem',
    border: '0',
    borderRadius: '6px',
    justifyContent: 'center !important',
  },
}

export default designStyle
